// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"4beaddbf","143":"c2fe5043","272":"657c51dc","342":"7b7b53e2","406":"a47ba8cc","543":"7edf2f05","556":"51daa972","597":"abd90670","640":"97f0cf69","679":"4beaddbf","719":"3115a61e","770":"e483495f","785":"657c51dc","798":"51bf1f83","941":"b18999f1"}[chunkId] + ".css";
};